export function formatCurrency(value, options = {}) {
  const amount = Number(value || 0);

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: options.minimumFractionDigits ?? 0,
    maximumFractionDigits: options.maximumFractionDigits ?? 0,
  }).format(amount);
}

export function formatPercent(value, options = {}) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "—";
  }

  return `${Number(value).toFixed(options.decimals ?? 2)}%`;
}

export function sortMesAno(a, b) {
  if (!a || !b) return 0;

  const [mesA, anoA] = String(a).split("/").map(Number);
  const [mesB, anoB] = String(b).split("/").map(Number);

  if (anoA !== anoB) {
    return anoA - anoB;
  }

  return mesA - mesB;
}

export function toMonthLabel(value) {
  return String(value || "").trim();
}

const MONTH_NAMES = [
  "Janeiro",
  "Fevereiro",
  "Marco",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];

export function formatMonthYearLabel(value) {
  const normalized = String(value || "").trim();
  const match = normalized.match(/^(\d{1,2})\/(\d{4})$/);

  if (!match) {
    return normalized;
  }

  const month = Number(match[1]);
  if (!Number.isInteger(month) || month < 1 || month > 12) {
    return normalized;
  }

  const paddedMonth = String(month).padStart(2, "0");
  const year = match[2];
  return `${MONTH_NAMES[month - 1]} - ${paddedMonth}/${year}`;
}

export function parseNumericInput(value) {
  const normalized = String(value ?? "")
    .replace(/[^\d,-]/g, "")
    .replace(/\./g, "")
    .replace(",", ".");

  const numericValue = Number(normalized);
  return Number.isFinite(numericValue) ? numericValue : 0;
}

export function buildCurrencyInputValue(value) {
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));
}
